import { Link } from "react-router-dom";

const showcasePieces = [
  {
    id: 1,
    slug: "aurelia-heritage-settee",
    label: "HERITAGE SEATING",
    name: "The Aurelia Heritage Settee",
    description: "A graceful expression of classical European seating, the Aurelia Heritage Settee blends sculptural woodwork with refined upholstery. Handcrafted to evoke timeless elegance, it serves as both a functional seating piece and a statement of heritage luxury.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9bbcadf0-3e41-44d6-8af8-0828b3695f86_settee.jpeg?v=4ed9c6a101cdf6b6bed89cf693a57db7",
    reversed: false,
  },
  {
    id: 2,
    slug: "bedroom-bed-versailles-cane",
    label: "BEDROOM",
    name: "Versailles Cane Heritage Bed",
    description: "A refined expression of French heritage, this cane-backed bed blends delicate carving with timeless elegance. Crafted for interiors that celebrate softness, symmetry, and artisanal detail.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/d6191fdd-ad37-47cb-b26b-f0a514a2f221_Bed-1.jpeg?v=bc824356f97ba9d221b98003d23ebeb5",
    reversed: true,
  },
  {
    id: 3,
    slug: "din-001",
    label: "DINING",
    name: "Royal Heritage Dining Set",
    description: "Crafted from solid hardwood with refined joinery, this dining set reflects the enduring elegance of traditional heritage design. A timeless centerpiece for gatherings that demand both beauty and substance.",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/35d585f8-6e61-4396-868c-7627af3a834d_Dining-1.jpeg?v=f13ae27f007fc5352927dcdbf3b614e4",
    reversed: false,
  },
];

export default function SignaturePieces() {
  return (
    <section className="bg-brand-cream py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="font-display text-brand-gold text-xs tracking-[4px] uppercase block mb-4">Curated Excellence</span>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-darkbrown font-bold">
            Signature <em>Masterpieces</em>
          </h2>
          <p className="font-sans text-brand-muted mt-4 max-w-xl mx-auto text-sm leading-relaxed">
            Each signature piece tells a story of unparalleled skill, exceptional materials, and a legacy
            of craftsmanship that transcends generations.
          </p>
        </div>

        {/* Pieces */}
        <div className="space-y-24">
          {showcasePieces.map((piece) => (
            <div
              key={piece.id}
              className={`flex flex-col lg:flex-row items-center gap-12 ${piece.reversed ? "lg:flex-row-reverse" : ""}`}
            >
              {/* Image */}
              <div className="w-full lg:w-3/5 relative">
                <div className="relative rounded-lg overflow-hidden">
                  <div className="w-full h-[420px]">
                    <img
                      src={piece.image}
                      alt={piece.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  {/* Frame Effect */}
                  <div className="absolute inset-3 border border-brand-gold/30 rounded pointer-events-none" />
                </div>
                {/* Decorative Year Badge */}
                <div className={`absolute -bottom-5 ${piece.reversed ? "left-6" : "right-6"} bg-brand-gold text-brand-darkbrown font-serif text-2xl font-bold w-20 h-20 rounded-full flex items-center justify-center`}>
                  <span className="text-sm font-display font-bold tracking-tight text-center leading-tight">EST<br />1870</span>
                </div>
              </div>

              {/* Content */}
              <div className={`w-full lg:w-2/5 ${piece.reversed ? "lg:pr-4" : "lg:pl-4"}`}>
                <span className="font-display text-brand-gold text-[10px] tracking-[4px] uppercase block mb-4">
                  {piece.label}
                </span>
                <h3 className="font-serif text-3xl md:text-4xl text-brand-darkbrown font-bold mb-6 leading-tight">
                  {piece.name}
                </h3>
                <p className="font-sans text-brand-muted text-sm leading-[1.9] mb-8">
                  {piece.description}
                </p>

                <Link
                  to={`/product/${piece.slug}`}
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 font-display text-xs tracking-widest uppercase px-8 py-3.5 bg-transparent border-[1.5px] border-brand-gold text-brand-gold rounded-full hover:bg-brand-gold hover:text-brand-darkbrown transition-all duration-300 cursor-pointer"
                >
                  Explore Details
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
